import React from 'react';
import { Vertical } from './social-share';

export function VerticalColor(props) {
  return <Vertical {...props} />;
}